import { menuRoutes } from "@/router";

/**
 * 格式化路由
 * @param {*[]} routes
 * @param {string[]} roles
 * @returns
 */
export const formatRouter = (routes, permissions) => {
	const fmtRoutes = [];

	routes.forEach((route) => {
		const { children, ...rest } = route;

		const currentPermissions = rest.meta.permission;

		if (!rest.meta.onlyMenu) {
			if (!currentPermissions) {
				fmtRoutes.push({ ...rest });
			}

			if (typeof currentPermissions === "string") {
				if (permissions.includes(currentPermissions.toLowerCase())) {
					fmtRoutes.push({ ...rest });
				}
			}

			if (Array.isArray(currentPermissions)) {
				const hasPermission = currentPermissions.some((role) => {
					const node = role.toLowerCase();

					return permissions.includes(node);
				});

				if (hasPermission) {
					fmtRoutes.push({ ...rest });
				}
			}
		}

		if (children && children.length > 0) {
			fmtRoutes.push(...formatRouter(children, permissions));
		}
	});

	return fmtRoutes;
};

/**
 * 格式化菜单
 * @param {*[]} routes
 * @returns
 */
export const formatMenu = (routes, permissions) => {
	const fmtRoutes = [];

	routes.forEach((route) => {
		const { children, meta = {}, ...rest } = route;

		// // 如果没有子节点，直接判断权限
		if (children === undefined || !Array.isArray(children)) {
			// 如果没有权限字段，则直接添加
			if (!meta.permission) {
				fmtRoutes.push({ ...rest, ...meta });
			} else {
				const currentPermissions = typeof meta.permission === "string" ? [meta.permission] : meta.permission;

				const hasPermission = currentPermissions.some((role) => {
					const node = role.toLowerCase();

					return permissions.includes(node);
				});

				if (hasPermission) {
					fmtRoutes.push({ ...rest, ...meta });
				}
			}
		} else {
			const newChildren = formatMenu(children, permissions);

			// 有子节点并且可访问的子节点大于0，否则不渲染对应菜单
			if (newChildren.length > 0) {
				fmtRoutes.push({ ...rest, ...meta, children: newChildren });
			}
		}
	});

	return fmtRoutes;
};

/**
 * 根据路由菜单顺序给权限列表排序
 */
export const formatAuthList = (authList) => {
	const menuMap = new Map();

	menuRoutes.forEach(({ children = [], meta }, index) => {
		const newChildren = {};

		children.forEach(({ meta }, childIndex) => {
			newChildren[meta.title] = childIndex;
		});

		// 基础设置是tab页，只能暂时写死单独处理
		if (meta.title === "基础设置") {
			menuMap.set(meta.title, {
				title: meta.title,
				sort: index,
				child: {
					账号管理: 0,
					权限管理: 1,
					分单配置: 2,
					币种配置: 3,
					BOM表配置: 4,
					审版配置: 5
				}
			});
		} else {
			menuMap.set(meta.title, {
				title: meta.title,
				sort: index,
				child: newChildren
			});
		}
	});

	authList.sort((a, b) => {
		const aSort = menuMap.get(a.category).sort;
		const bSort = menuMap.get(b.category).sort;

		if (aSort === bSort) {
			return a.sort - b.sort;
		}

		return aSort - bSort;
	});

	authList.forEach((item) => {
		if (item.child && item.child.length > 0) {
			item.child.sort((a, b) => {
				const aSort = menuMap.get(item.category).child[a.title];
				const bSort = menuMap.get(item.category).child[b.title];

				return aSort - bSort;
			});
		}
	});

	return authList;
};
